'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Privacy = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Privacy, _Component);

  function Privacy() {
    (0, _classCallCheck3.default)(this, Privacy);
    return (0, _possibleConstructorReturn3.default)(this, (Privacy.__proto__ || (0, _getPrototypeOf2.default)(Privacy)).apply(this, arguments));
  }

  (0, _createClass3.default)(Privacy, [{
    key: 'render',
    value: function render() {
      var styles = require(this.props.mobile ? './IntroMobile.scss' : './Intro.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.intro },
        _react2.default.createElement(
          'div',
          { className: styles.title, style: this.props.customTitleStyle },
          'Ch\xEDnh s\xE1ch b\u1EA3o m\u1EADt th\xF4ng tin \u2013 Lookme.vn'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.introSection, style: this.props.customStyle },
          _react2.default.createElement(
            'div',
            { className: styles.header, style: this.props.customHeaderStyle },
            'M\u1EE5c \u0111\xEDch thu th\u1EADp th\xF4ng tin c\xE1 nh\xE2n'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Vi\u1EC7c thu th\u1EADp d\u1EEF li\u1EC7u ch\u1EE7 y\u1EBFu tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn bao g\u1ED3m: email, \u0111i\u1EC7n tho\u1EA1i, t\xEAn \u0111\u0103ng nh\u1EADp, m\u1EADt kh\u1EA9u \u0111\u0103ng nh\u1EADp, \u0111\u1ECBa ch\u1EC9 kh\xE1ch h\xE0ng (th\xE0nh vi\xEAn). \u0110\xE2y l\xE0 c\xE1c th\xF4ng tin m\xE0 Lookme.vn c\u1EA7n th\xE0nh vi\xEAn cung c\u1EA5p b\u1EAFt bu\u1ED9c khi \u0111\u0103ng k\xFD s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 v\xE0 \u0111\u1EC3 Lookme.vn li\xEAn h\u1EC7 x\xE1c nh\u1EADn khi kh\xE1ch h\xE0ng \u0111\u0103ng k\xFD s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 tr\xEAn website nh\u1EB1m \u0111\u1EA3m b\u1EA3o quy\u1EC1n l\u1EE3i cho cho ng\u01B0\u1EDDi ti\xEAu d\xF9ng.',
            ' '
          ),
          _react2.default.createElement(
            'p',
            null,
            'C\xE1c th\xE0nh vi\xEAn s\u1EBD t\u1EF1 ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 b\u1EA3o m\u1EADt v\xE0 l\u01B0u gi\u1EEF m\u1ECDi ho\u1EA1t \u0111\u1ED9ng s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 d\u01B0\u1EDBi t\xEAn \u0111\u0103ng k\xFD, m\u1EADt kh\u1EA9u v\xE0 h\u1ED9p th\u01B0 \u0111i\u1EC7n t\u1EED c\u1EE7a m\xECnh. Ngo\xE0i ra, th\xE0nh vi\xEAn c\xF3 tr\xE1ch nhi\u1EC7m th\xF4ng b\xE1o k\u1ECBp th\u1EDDi cho Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn v\u1EC1 nh\u1EEFng h\xE0nh vi s\u1EED d\u1EE5ng tr\xE1i ph\xE9p, l\u1EA1m d\u1EE5ng, vi ph\u1EA1m b\u1EA3o m\u1EADt, l\u01B0u gi\u1EEF t\xEAn \u0111\u0103ng k\xFD v\xE0 m\u1EADt kh\u1EA9u c\u1EE7a b\xEAn th\u1EE9 ba \u0111\u1EC3 c\xF3 bi\u1EC7n ph\xE1p gi\u1EA3i quy\u1EBFt ph\xF9 h\u1EE3p.',
            ' '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.header, style: this.props.customHeaderStyle },
            'Ph\u1EA1m vi thu th\u1EADp th\xF4ng tin'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn s\u1EED d\u1EE5ng th\xF4ng tin th\xE0nh vi\xEAn cung c\u1EA5p \u0111\u1EC3:'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- Cung c\u1EA5p c\xE1c d\u1ECBch v\u1EE5 \u0111\u1EBFn Th\xE0nh vi\xEAn;'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- G\u1EEDi c\xE1c th\xF4ng b\xE1o v\u1EC1 c\xE1c ho\u1EA1t \u0111\u1ED9ng trao \u0111\u1ED5i th\xF4ng tin gi\u1EEFa th\xE0nh vi\xEAn v\xE0 Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn;'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- Ng\u0103n ng\u1EEBa c\xE1c ho\u1EA1t \u0111\u1ED9ng ph\xE1 h\u1EE7y t\xE0i kho\u1EA3n ng\u01B0\u1EDDi d\xF9ng c\u1EE7a th\xE0nh vi\xEAn ho\u1EB7c c\xE1c ho\u1EA1t \u0111\u1ED9ng gi\u1EA3 m\u1EA1o Th\xE0nh vi\xEAn;'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- Li\xEAn l\u1EA1c v\xE0 gi\u1EA3i quy\u1EBFt v\u1EDBi th\xE0nh vi\xEAn trong nh\u1EEFng tr\u01B0\u1EDDng h\u1EE3p \u0111\u1EB7c bi\u1EC7t.'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- Kh\xF4ng s\u1EED d\u1EE5ng th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn ngo\xE0i m\u1EE5c \u0111\xEDch x\xE1c nh\u1EADn v\xE0 li\xEAn h\u1EC7 c\xF3 li\xEAn quan \u0111\u1EBFn giao d\u1ECBch t\u1EA1i Lookme.vn.'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- Trong tr\u01B0\u1EDDng h\u1EE3p c\xF3 y\xEAu c\u1EA7u c\u1EE7a ph\xE1p lu\u1EADt: Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn c\xF3 tr\xE1ch nhi\u1EC7m h\u1EE3p t\xE1c cung c\u1EA5p th\xF4ng tin c\xE1 nh\xE2n th\xE0nh vi\xEAn khi c\xF3 y\xEAu c\u1EA7u t\u1EEB c\u01A1 quan t\u01B0 ph\xE1p bao g\u1ED3m: Vi\u1EC7n ki\u1EC3m s\xE1t, t\xF2a \xE1n, c\u01A1 quan c\xF4ng an \u0111i\u1EC1u tra li\xEAn quan \u0111\u1EBFn h\xE0nh vi vi ph\u1EA1m ph\xE1p lu\u1EADt n\xE0o \u0111\xF3 c\u1EE7a kh\xE1ch h\xE0ng. Ngo\xE0i ra, kh\xF4ng ai c\xF3 quy\u1EC1n x\xE2m ph\u1EA1m v\xE0o th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn.'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.header, style: this.props.customHeaderStyle },
            'Th\u1EDDi gian l\u01B0u tr\u1EEF th\xF4ng tin'
          ),
          _react2.default.createElement(
            'p',
            null,
            'D\u1EEF li\u1EC7u c\xE1 nh\xE2n c\u1EE7a Th\xE0nh vi\xEAn s\u1EBD \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF cho \u0111\u1EBFn khi c\xF3 y\xEAu c\u1EA7u h\u1EE7y b\u1ECF ho\u1EB7c t\u1EF1 th\xE0nh vi\xEAn \u0111\u0103ng nh\u1EADp v\xE0 th\u1EF1c hi\u1EC7n h\u1EE7y b\u1ECF. C\xF2n l\u1EA1i trong m\u1ECDi tr\u01B0\u1EDDng h\u1EE3p th\xF4ng tin c\xE1 nh\xE2n th\xE0nh vi\xEAn s\u1EBD \u0111\u01B0\u1EE3c b\u1EA3o m\u1EADt tr\xEAn m\xE1y ch\u1EE7 c\u1EE7a Lookme.vn'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.header, style: this.props.customHeaderStyle },
            '\u0110\u1ECBa ch\u1EC9 \u0111\u01A1n v\u1ECB thu th\u1EADp v\xE0 qu\u1EA3n l\xFD th\xF4ng tin c\xE1 nh\xE2n'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- V\u0103n ph\xF2ng giao d\u1ECBch: 481/14 \u0110\u01B0\u1EDDng s\u1ED1 10, Ph\u01B0\u1EDDng 8, Qu\u1EADn G\xF2 V\u1EA5p, Th\xE0nh ph\u1ED1 H\u1ED3 Ch\xED Minh'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- S\u1ED1 \u0111i\u1EC7n tho\u1EA1i: 0933207298 Email: hr@lookme.vn'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.header, style: this.props.customHeaderStyle },
            'Ph\u01B0\u01A1ng ti\u1EC7n v\xE0 c\xF4ng c\u1EE5 \u0111\u1EC3 ng\u01B0\u1EDDi d\xF9ng ti\u1EBFp c\u1EADn v\xE0 ch\u1EC9nh s\u1EEDa d\u1EEF li\u1EC7u c\xE1 nh\xE2n c\u1EE7a m\xECnh'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Th\xE0nh vi\xEAn c\xF3 quy\u1EC1n t\u1EF1 ki\u1EC3m tra, c\u1EADp nh\u1EADt, \u0111i\u1EC1u ch\u1EC9nh ho\u1EB7c h\u1EE7y b\u1ECF th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a m\xECnh b\u1EB1ng c\xE1ch \u0111\u0103ng nh\u1EADp v\xE0o t\xE0i kho\u1EA3n v\xE0 ch\u1EC9nh s\u1EEDa th\xF4ng tin c\xE1 nh\xE2n ho\u1EB7c y\xEAu c\u1EA7u Lookme.vn th\u1EF1c hi\u1EC7n vi\u1EC7c n\xE0y. Khi ti\u1EBFp nh\u1EADn nh\u1EEFng ph\u1EA3n h\u1ED3i n\xE0y, Lookme.vn s\u1EBD x\xE1c nh\u1EADn l\u1EA1i th\xF4ng tin, ph\u1EA3i c\xF3 tr\xE1ch nhi\u1EC7m tr\u1EA3 l\u1EDDi l\xFD do v\xE0 h\u01B0\u1EDBng d\u1EABn th\xE0nh vi\xEAn kh\xF4i ph\u1EE5c ho\u1EB7c x\xF3a b\u1ECF th\xF4ng tin c\xE1 nh\u1EADn kh\xE1ch h\xE0ng.'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.header, style: this.props.customHeaderStyle },
            'Cam k\u1EBFt b\u1EA3o m\u1EADt th\xF4ng tin c\xE1 nh\xE2n kh\xE1ch h\xE0ng'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn tr\xEAn Lookme.vn \u0111\u01B0\u1EE3c Lookme.vn cam k\u1EBFt b\u1EA3o m\u1EADt tuy\u1EC7t \u0111\u1ED1i theo ch\xEDnh s\xE1ch b\u1EA3o v\u1EC7 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a Lookme.vn. Vi\u1EC7c thu th\u1EADp v\xE0 s\u1EED d\u1EE5ng th\xF4ng tin c\u1EE7a m\u1ED7i th\xE0nh vi\xEAn ch\u1EC9 \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n khi c\xF3 s\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a kh\xE1ch h\xE0ng \u0111\xF3 tr\u1EEB nh\u1EEFng tr\u01B0\u1EDDng h\u1EE3p ph\xE1p lu\u1EADt c\xF3 quy \u0111\u1ECBnh kh\xE1c.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Kh\xF4ng s\u1EED d\u1EE5ng, kh\xF4ng chuy\u1EC3n giao, cung c\u1EA5p hay ti\u1EBFt l\u1ED9 cho b\xEAn th\u1EE9 3 n\xE0o v\u1EC1 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn khi kh\xF4ng c\xF3 s\u1EF1 cho ph\xE9p \u0111\u1ED3ng \xFD t\u1EEB th\xE0nh vi\xEAn.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Trong tr\u01B0\u1EDDng h\u1EE3p m\xE1y ch\u1EE7 l\u01B0u tr\u1EEF th\xF4ng tin b\u1ECB hacker t\u1EA5n c\xF4ng d\u1EABn \u0111\u1EBFn m\u1EA5t m\xE1t d\u1EEF li\u1EC7u c\xE1 nh\xE2n th\xE0nh vi\xEAn, Lookme.vn s\u1EBD c\xF3 tr\xE1ch nhi\u1EC7m th\xF4ng b\xE1o v\u1EE5 vi\u1EC7c cho c\u01A1 quan ch\u1EE9c n\u0103ng \u0111i\u1EC1u tra x\u1EED l\xFD k\u1ECBp th\u1EDDi v\xE0 th\xF4ng b\xE1o cho th\xE0nh vi\xEAn \u0111\u01B0\u1EE3c bi\u1EBFt.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'B\u1EA3o m\u1EADt tuy\u1EC7t \u0111\u1ED1i m\u1ECDi th\xF4ng tin giao d\u1ECBch tr\u1EF1c tuy\u1EBFn c\u1EE7a Th\xE0nh vi\xEAn bao g\u1ED3m th\xF4ng tin h\xF3a \u0111\u01A1n k\u1EBF to\xE1n ch\u1EE9ng t\u1EEB s\u1ED1 h\xF3a t\u1EA1i khu v\u1EF1c d\u1EEF li\u1EC7u trung t\xE2m an to\xE0n c\u1EA5p 1 c\u1EE7a Lookme.vn.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Ban qu\u1EA3n l\xFD Lookme.vn y\xEAu c\u1EA7u c\xE1c c\xE1 nh\xE2n khi \u0111\u0103ng k\xFD/mua h\xE0ng l\xE0 th\xE0nh vi\xEAn, ph\u1EA3i cung c\u1EA5p \u0111\u1EA7y \u0111\u1EE7 th\xF4ng tin c\xE1 nh\xE2n c\xF3 li\xEAn quan nh\u01B0: H\u1ECD v\xE0 t\xEAn, \u0111\u1ECBa ch\u1EC9 li\xEAn l\u1EA1c, email, s\u1ED1 ch\u1EE9ng minh nh\xE2n d\xE2n, \u0111i\u1EC7n tho\u1EA1i, s\u1ED1 t\xE0i kho\u1EA3n, s\u1ED1 th\u1EBB thanh to\xE1n \u2026., v\xE0 ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 t\xEDnh ph\xE1p l\xFD c\u1EE7a nh\u1EEFng th\xF4ng tin tr\xEAn. Ban qu\u1EA3n l\xFD Lookme.vn kh\xF4ng ch\u1ECBu tr\xE1ch nhi\u1EC7m c\u0169ng nh\u01B0 kh\xF4ng gi\u1EA3i quy\u1EBFt m\u1ECDi khi\u1EBFu n\u1EA1i c\xF3 li\xEAn quan \u0111\u1EBFn quy\u1EC1n l\u1EE3i c\u1EE7a Th\xE0nh vi\xEAn \u0111\xF3 n\u1EBFu x\xE9t th\u1EA5y t\u1EA5t c\u1EA3 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn \u0111\xF3 cung c\u1EA5p khi \u0111\u0103ng k\xFD ban \u0111\u1EA7u l\xE0 kh\xF4ng ch\xEDnh x\xE1c.'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.header, style: this.props.customHeaderStyle },
            'C\u01A1 ch\u1EBF ti\u1EBFp nh\u1EADn v\xE0 gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i li\xEAn quan \u0111\u1EBFn vi\u1EC7c th\xF4ng tin c\xE1 nh\xE2n kh\xE1ch h\xE0ng'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Th\xE0nh vi\xEAn c\xF3 quy\u1EC1n g\u1EEDi khi\u1EBFu n\u1EA1i v\u1EC1 vi\u1EC7c l\u1ED9 th\xF4ng tin c\xE1c nh\xE2n cho b\xEAn th\u1EE9 3 \u0111\u1EBFn Ban qu\u1EA3n tr\u1ECB c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED Lookme.vn \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 C\xF4ng ty ho\u1EB7c qua email.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Email: hr@lookme.vn'
          ),
          _react2.default.createElement(
            'p',
            null,
            'C\xF4ng ty c\xF3 tr\xE1ch nhi\u1EC7m th\u1EF1c hi\u1EC7n c\xE1c bi\u1EC7n ph\xE1p k\u1EF9 thu\u1EADt, nghi\u1EC7p v\u1EE5 \u0111\u1EC3 x\xE1c minh c\xE1c n\u1ED9i dung \u0111\u01B0\u1EE3c ph\u1EA3n \xE1nh.',
            ' '
          ),
          _react2.default.createElement(
            'p',
            null,
            'Th\u1EDDi gian x\u1EE9 l\xFD ph\u1EA3n \xE1nh li\xEAn quan \u0111\u1EBFn th\xF4ng tin c\xE1 nh\xE2n kh\xE1ch h\xE0ng l\xE0 15 ng\xE0y.'
          )
        )
      );
    }
  }]);
  return Privacy;
}(_react.Component), _class.propTypes = {
  customTitleStyle: _react.PropTypes.any,
  customStyle: _react.PropTypes.any,
  customHeaderStyle: _react.PropTypes.any,
  mobile: _react.PropTypes.bool
}, _temp);
exports.default = Privacy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Policy/Privacy.js
// module id = 1653
// module chunks = 0